export { default as Body } from './Body';
export { default as Small } from './Small';
export { default as Heading } from './Heading';
